import {useEffect, useRef} from "react";

export default function useFocusInvalid(
    validationCount: number,
    firstInvalidElement?: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | null,
) {
    const prevCountRef = useRef<number | null>(null);
    useEffect(() => {
        prevCountRef.current = validationCount;
    }, [validationCount]);
    const prevCount = prevCountRef.current;

    useEffect(() => {
        if (!firstInvalidElement || prevCount === null || validationCount <= prevCount) {
            return;
        }

        firstInvalidElement.scrollIntoView();
        firstInvalidElement.focus();
    }, [validationCount, prevCount, firstInvalidElement]);
}
